/* eslint-disable no-unused-vars */
import { MatchByMatchState } from './match-by-match/types';
import { RoundByRoundState } from './round-by-round/types';
import { PlayerModalState } from './player-modal/types';
import { LeaderboardState } from './leaderboard/types';
import { TooltipState } from './tooltip/types';

/**
 * @typedef {object} BrownlowTrackerState
 * @property {MatchByMatchState} matchByMatch
 * @property {RoundByRoundState} roundByRound
 * @property {PlayerModalState} playerModal
 * @property {LeaderboardState} leaderboard
 * @property {TooltipState} tooltip
 */
